jQuery(document).ready(function ($) {
    if (!document.querySelector('body.gp-endpoint-pos-coupons')) {
        return;
    }

    var $searchForm = $('.pos__search_form');
    var $searchInput = $searchForm.find('input[name="search"]');
    var $empty = $('.pos__empty');
    var $loading = $('.pos__coupons_loading');
    var $couponDetail = $('.coupon-detail');
    var $alertBox = $('.pos__coupons_alert');
    var debounceTimeout, currentRequest = null;
    var defaultEmptyHtml = $empty.html();

    // Initialization
    $empty.show();
    $loading.hide();
    $couponDetail.hide();
    $alertBox.hide();

    function searchCoupon(couponCode) {
        var requestCouponCode = couponCode;
        $couponDetail.hide();
        $alertBox.hide();
        $empty.hide();
        if (currentRequest) currentRequest.abort();

        currentRequest = gp_ajax({
            url: ghostpress_params.ajax_url,
            type: 'POST',
            dataType: 'json',
            data: {
                action: 'coupon_search',
                coupon_code: couponCode
            },
            success: function (response) {
                var currentCode = $.trim($searchInput.val());
                if (currentCode !== requestCouponCode) return;
                $loading.hide();
                currentRequest = null;

                if (response.success) {
                    var html = '';
                    if (response.data.fragments && response.data.fragments.replace) {
                        $.each(response.data.fragments.replace, function (_, fragmentHtml) {
                            html += fragmentHtml;
                        });
                    }
                    if (!html && response.data.coupon_html) {
                        html = response.data.coupon_html;
                    }
                    if (html) {
                        $couponDetail.html(html).show();
                        $empty.hide();
                    } else {
                        $couponDetail
                            .html('<div class="pos__empty --l"><h2 class="pos__empty-title">Neznámá odpověď serveru</h2></div>')
                            .show();
                    }
                } else {
                    $couponDetail.hide();
                    $empty
                        .html('<div class="pos__empty --l"><h2 class="pos__empty-title">Nic nenalezeno</h2></div>')
                        .show();
                }
            },
            error: function () {
                $loading.hide();
                $alertBox.text('Chyba při komunikaci se serverem.').show();
            }
        });
    }

    $searchInput.on('input', function () {
        var couponCode = $.trim($searchInput.val());
        clearTimeout(debounceTimeout);
        $loading.hide();

        if (couponCode.length >= 6) {
            $couponDetail.hide();
            $alertBox.hide();
            $empty.hide();
            $loading.show();

            debounceTimeout = setTimeout(function () {
                searchCoupon(couponCode);
            }, 500);
        } else if (couponCode.length === 0) {
            $couponDetail.hide();
            $alertBox.hide();
            $empty.html(defaultEmptyHtml).show();
        }
    });

    $searchForm.on('submit', function (e) {
        e.preventDefault();
        var couponCode = $.trim($searchInput.val());
        if (couponCode.length > 0) {
            clearTimeout(debounceTimeout);
            $empty.hide();
            $loading.show();
            searchCoupon(couponCode);
        }
    });
    $('.pos__search_clear').on('click', function () {
        $searchInput.val('');
        clearTimeout(debounceTimeout);
        $loading.hide();
        $couponDetail.hide();
        $alertBox.hide();
        $empty.html(defaultEmptyHtml).show();
    });
});
